/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Empty } from '../../models/empty';

export interface UsersUserIdInvitationPost$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
}

export function usersUserIdInvitationPost(http: HttpClient, rootUrl: string, params: UsersUserIdInvitationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: Empty;
}>> {
  const rb = new RequestBuilder(rootUrl, usersUserIdInvitationPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: Empty;
      }>;
    })
  );
}

usersUserIdInvitationPost.PATH = '/users/{userId}/invitation';
